import {API} from "../api/axios";
const END_POINT = "/students";
const END_POINT_FILTER = "/students-filter";
const END_POINT_STUDENT = "/student";
const END_POINT_PARENT = "/check-parent-email";
const END_POINT_YEAR = "/school-year";
const END_POINT_UPDATE_CLASS = "/update-students-class";
const END_POINT_SCOLARITE = "/students-scolarity-filter";
const END_POINT_ENABLE = "/enable-disable-student";

class StudentService {
  checkParent(params) {
    return API.get(`${END_POINT_PARENT}`, params);
  }
  getAllyear(params) {
    return API.get(END_POINT_YEAR, params);
  }
  getAll(params) {
    return API.get(END_POINT, params);
  }
  getFilter(params) {
    return API.get(END_POINT_FILTER, params);
  }
  getFilterScolarity(params) {
    return API.get(END_POINT_SCOLARITE, params);
  }
  get(id) {
    return API.get(`${END_POINT_STUDENT}${END_POINT}/${id}`);
  }
  create(data) {
    return API.post(END_POINT_STUDENT, data);
  }
  update(id, data) {
    return API.post(`${END_POINT_STUDENT}/${id}`, data);
  }
  delete(id) {
    return API.delete(`${END_POINT_STUDENT}/${id}`);
  }
  deleteAll(params) {
    return API.delete(`${END_POINT}`, params);
  }
  addClass(params) {
    return API.post(END_POINT_UPDATE_CLASS, params);
  }
  enableStudent(id, data) {
    return API.post(`${END_POINT_ENABLE}/${id}`, data);
  }
}

export default new StudentService();
